import React from "react";
import { createTheme, Grid, IconButton, ThemeProvider } from "@material-ui/core";
import useStyles from "../../assets/styles";
import { RedirectIcon } from "src/components/Icons";
import { clickBack } from "src/app/utils";
import {useHistory} from 'react-router-dom';

export const ITSMTitleComponent = () => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    const history = useHistory();
    return (
        <ThemeProvider theme={theme}>
            <Grid container className={classes.pageTitleContainer} style={{paddingLeft:'0px'}}>
                <IconButton onClick={() => clickBack(history, "/TestAutomation")}>
                    <RedirectIcon />
                </IconButton>
                <Grid className={classes.pageTitle} style={{margin:'0px'}}>ITSM Configuration - Step 06</Grid>
            </Grid>
        </ThemeProvider>
    );
};

